/**
 * Mirrors Bosca.Shield.Cloud.Data.Entity.Profile.ProfileStatus (server enum names).
 */
export const SITE_PROFILE_STATUSES_BULK_RETRY = [
  'Active',
  'EditInProgress',
  'InductionInProgress',
  'InductionFailed',
  'DeletionInProgress',
  'DeletionFailed',
  'Deleted',
  'Draft',
  'Expired',
];

export const DEFAULT_BULK_RETRY_INDUCTION_STATUSES = ['InductionFailed', 'InductionInProgress'];
